import React from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const mockCitations = [
  { directory: 'Google Assistant', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Google Business Profile', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Google Search', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Bing', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Facebook', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Instagram', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Siri', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Foursquare', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
  { directory: 'Apple Maps ...', address: 'A-611, Bestech Business Tower,', status: 'Wrong Address', phone: '8585457485' },
];

const Container = styled(Box)(({ theme }) => ({
  padding: '24px',
  backgroundColor: '#f5f7fa',
  minHeight: '100vh',
}));

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px',
  flexWrap: 'wrap',
  gap: '16px',
}));

const TitleSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

const TitleIcon = styled(Box)(({ theme }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
}));

const InfoCard = styled(Card)(({ theme }) => ({
  padding: '20px',
  borderRadius: '16px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  marginBottom: '24px',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px',
}));

const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  overflow: 'hidden',
}));

const Th = styled(TableCell)(({ theme }) => ({
  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  color: '#ffffff',
  fontWeight: 600,
  padding: '16px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
}));

const Td = styled(TableCell)(({ theme }) => ({
  padding: '14px 16px',
  borderBottom: '1px solid #f0f0f0',
  fontSize: '14px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#eff6ff',
  },
}));

const LocalCitation = () => {
  return (
    <Container>
      <Header>
        <TitleSection>
          <TitleIcon>
            <LocationOnIcon fontSize="large" />
          </TitleIcon>
          <Box>
            <Typography variant="h4" fontWeight={700} color="#1f2937">Local Citation</Typography>
            <Typography variant="body2" color="text.secondary">Manage your business listings across directories for NAP consistency.</Typography>
          </Box>
        </TitleSection>
      </Header>

      <InfoCard>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>Selected Account</Typography>
          <Typography variant="subtitle1" fontWeight={600} color="#1f2937">Dr. Sunita Sofat Hospital - Test Tube Baby | Best IVF Centre in Ludhiana, Punjab</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>Location</Typography>
          <Typography variant="subtitle1" fontWeight={600} color="#1f2937">A-611, Bestech Business Tower, Sector 66, SAS Nagar, Punjab 160066</Typography>
        </Box>
      </InfoCard>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Typography variant="h6" fontWeight={600} color="#1f2937">Listings To Fix</Typography>
        <Chip
          label="32 / 35"
          sx={{
            bgcolor: '#fef3c7',
            color: '#92400e',
            fontWeight: 600,
            fontSize: '14px',
          }}
        />
      </Box>

      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <Th>Directory</Th>
              <Th>Address</Th>
              <Th>Status</Th>
              <Th>Phone Number</Th>
              <Th>Status</Th>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockCitations.map((citation, index) => (
              <StyledTableRow key={index}>
                <Td>
                  <Typography variant="subtitle2" fontWeight={600} color="#1f2937">
                    {citation.directory}
                  </Typography>
                </Td>
                <Td>{citation.address}</Td>
                <Td>
                  <Chip
                    label={citation.status}
                    size="small"
                    sx={{
                      bgcolor: '#fee2e2',
                      color: '#dc2626',
                      fontWeight: 600,
                      fontSize: '11px',
                    }}
                  />
                </Td>
                <Td>{citation.phone}</Td>
                <Td>
                  <Chip
                    label={citation.status}
                    size="small"
                    sx={{
                      bgcolor: '#fee2e2',
                      color: '#dc2626',
                      fontWeight: 600,
                      fontSize: '11px',
                    }}
                  />
                </Td>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainerStyled>
    </Container>
  );
};

export default LocalCitation;

